// components/StudentRecord/ViewAgentApplicationForm.jsx
import { motion, AnimatePresence } from "framer-motion";
import { AGENT_SECTION_KEYS, AGENT_SECTION_LABELS } from "../../../constants.js";
import ViewAgentForm from "./ViewAgentForm.jsx";
import AgentInternalForm from "../AgentInternalForm.js";
import LinkedStudentsList from "./LinkedStudentsList.jsx";
import ViewStudentRecordForm from "../StudentForms/ViewStudentRecordForm";
import CommissionsDetails from "./CommissionsDetails.jsx";
import AgentAnalyticsDetails from "./AgentAnalyticsDetails.jsx";
import React, { useEffect, useState } from "react";

export default function ViewAgentApplicationForm({ onCancel, initialData }) {

  const sectionMap = {
      agentApplication: ViewAgentForm,
      agentRecord: AgentInternalForm,
      agentAnalytics: AgentAnalyticsDetails,
      students: LinkedStudentsList,
      commissions: CommissionsDetails,
    };
 
  
  const [isNew, setIsNew] = useState(initialData.status === 'new');
  const [currentSection, setCurrentSection] = useState(isNew ? "agentApplication" : "agentRecord");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const CurrentComponent = sectionMap[currentSection];
  useEffect(() => {
      setIsNew(initialData.status === 'new');
    }, []);

  return (
    <div style={{ display: "flex", height: "100%", background: "#fff" }}>
      <div
        style={{
          width: 240,
          background: "#f9f9f9",
          borderRight: "2px solid #ddd",
          padding: "16px 0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {AGENT_SECTION_KEYS.filter(k => initialData.companyDetails || (isNew && k === 'agentApplication')).map((key) => (
          <div
            key={key}
            onClick={() => setCurrentSection(key)}
            style={{
              padding: "12px 20px",
              cursor: "pointer",
              color: currentSection === key ? "#007bff" : "#333",
              fontWeight: currentSection === key ? "bold" : "normal",
              backgroundColor: currentSection === key ? "#e6f0ff" : "transparent",
              borderLeft: currentSection === key ? "4px solid #007bff" : "4px solid transparent",
              marginBottom: 4,
              transition: "0.2s all",
            }}
          >
            {AGENT_SECTION_LABELS[key]}
          </div>
        ))}
        {AGENT_SECTION_KEYS.filter(k => !initialData.companyDetails && !isNew && k !== 'agentApplication').map((key) => (
          <div
            key={key}
            onClick={() => setCurrentSection(key)}
            style={{
              padding: "12px 20px",
              cursor: "pointer",
              color: currentSection === key ? "#007bff" : "#333",
              fontWeight: currentSection === key ? "bold" : "normal",
              backgroundColor: currentSection === key ? "#e6f0ff" : "transparent",
              borderLeft: currentSection === key ? "4px solid #007bff" : "4px solid transparent",
              marginBottom: 4,
              transition: "0.2s all",
            }}
          >
            {AGENT_SECTION_LABELS[key]}
          </div>
        ))}
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, padding: currentSection !== "agentApplication" ? 20 : 0, marginTop: currentSection !== "agentApplication" ? 0 : -20 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentSection}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
          >
            {initialData ? (
              currentSection === "agentApplication" && ( initialData.status === "new" || initialData.companyDetails) ? (
                <CurrentComponent initialData={initialData} onCancel={onCancel} />
              ) :  currentSection.startsWith("agentRecord") ? (
                <CurrentComponent onCancel={onCancel} initialData={initialData}/>
              )  : currentSection.startsWith("students") ? (
                selectedStudent ? (
                  <ViewStudentRecordForm
                    onCancel={() => setSelectedStudent(null)}
                    initialData={selectedStudent}
                  />
                ) : (
                  <LinkedStudentsList
                    onCancel={onCancel}
                    initialData={initialData}
                    onSelectStudent={(student) => setSelectedStudent(student)}
                  />
                )
              ) :  currentSection.startsWith("agentRecord") ? (
                <CurrentComponent onCancel={onCancel} initialData={initialData}/>
              )  : (
                <div style={{ padding: "20px", color: "#666" }}>
                  <h2>No Record</h2>
                  <p>This agent is not linked.</p>
                </div>
              )
            ) : (
              <div style={{ padding: "20px", color: "#666" }}>
                <h2>No Record</h2>
                <p>This agent is not linked.</p>
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
